// t7-1b (T4, T5): EL MATERIAL DEL GRUPO PARA EL ALUMNO.
//
// La unica puerta del frontend a `GET /api/grupos/alumno/material` (el servidor
// vive en `backend/routes/grupo_alumno.py`). Devuelve la lista de grupos del
// alumno con sus cards, ya ordenada por el servidor:
//   [{ id, nombre, cards: [{ id, numero, nombre, nombre_propio, doc_id,
//      temas: [{ tema_id, nombre, count }], total, caduca, created_at, estado }] }]
//
// Dos compuertas antes de la red, en este orden:
//   1. (t7-3, A1, #557: la compuerta `IS_APP_BUILD` se retiro: la app pide la lista con
//      red igual que la web.) Sin usuario o con invitado: un invitado nunca ve grupos (A.2).
//   2. El fallo: cualquier error, o una respuesta sin `grupos`, devuelve [].
//      Quien la llama pinta una superficie opcional; un 500 aqui no puede tumbar
//      el Panel ni el Centro de estudio. Nunca rechaza.
//
// t7-1c (P): `alFallar`, el segundo parametro opcional, es lo que se devuelve en el
// caso 2 (el fallo) y SOLO en ese. Por omision es [], o sea lo de siempre: el Centro
// de estudio y todo el que no lo pase siguen igual. El Panel pasa `null` para
// distinguir "fallo" de "no hay grupos" y conservar lo que ya pintaba (un 5xx, la
// red o un 429 del freno no le borran los grupos que ya se veian). La compuerta 1 no
// es un fallo: el invitado recibe [] siempre, sin pedir.

export const RUTA_MATERIAL = '/grupos/alumno/material';

// El cliente HTTP se pide al LLAMAR, no al importar: `lib/api.js` arrastra
// `src/i18n.js`, y el Panel lo montan suites que no doblan `lib/api` (el mismo
// motivo, medido, que en `lib/referidos.js`).
function cliente() {
  return require('./api').default;
}

export async function cargarMaterialDelGrupo(user, alFallar = []) {
  if (!user || user.is_guest) return [];
  try {
    const res = await cliente().get(RUTA_MATERIAL);
    const grupos = res && res.data && res.data.grupos;
    return Array.isArray(grupos) ? grupos : alFallar;
  } catch (e) {
    return alFallar;
  }
}
